<template>
  <div
    class="button-wrapper"
    :style="dinamicStyle"
    :class="dinamicClass"
    @click="handleClick"
  >
    <slot name="icon"></slot>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";

type PropTypes = {
  type?: "primary" | "secondary" | "outline" | "dashed" | "text" | "normal";
  shape?: "square" | "round" | "circle" | "--";
  status?: "normal" | "warning" | "success" | "danger";
  size?: "mini" | "small" | "medium" | "large";
  long?: boolean;
  loading?: boolean;
  disabled?: boolean;
  htmlType?: "submit" | "reset" | "button";
  align?: "left" | "right" | "center";
  href?: string;
};

const emit = defineEmits(["click"]);
const props = withDefaults(defineProps<PropTypes>(), {
  type: "secondary",
  shape: "--",
  status: "normal",
  size: "medium",
  long: false,
  loading: false,
  disabled: false,
  htmlType: "button",
  align: "center",
  href: "",
});

const dinamicStyle = computed(() => ({
  textAlign: props.align ?? "center",
}));

// 其他属性待实现样式
const dinamicClass = computed(() => ({
  "button-disabled": props.disabled,
  mini: props.size == "mini",
  small: props.size == "small",
  medium: props.size == "medium",
  large: props.size == "large",
  square: props.shape == "square",
  round: props.shape == "round",
  normal: props.type == "normal",
  long: !!props.long,
}));

const handleClick = (ev: MouseEvent) => {
  if (props.disabled || props.loading) {
    ev.preventDefault();
    return;
  }
  emit("click", ev);
};

onMounted(() => {});
</script>

<style scoped lang="less">
.button-wrapper {
  display: flex;
  cursor: pointer;
  background-color: @primary-color;
  color: #fff;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 0 15px;
  font-size: 14px;
  &:hover {
    background-color: #A9823E;;
  }
  &.square {
    border-radius: 0;
  }
  &.round {
    border-radius: 20%;
  }
  &.button-disabled {
    color: rgb(178, 184, 193);
    background-color: rgb(242, 243, 245);
    cursor: not-allowed;
  }

  &.mini {
    height: 24px;
    font-size: 12px;
    padding: 0 11px;
  }

  &.small {
    height: 28px;
  }

  &.medium {
    height: 32px;
  }

  &.large {
    height: 44px;
    font-size: 16px;
    padding: 0 19px;
  }
  &.normal {
    background: #fff;
    color: #666;
    border: 1px solid #bbbbbb;
  }
  &.long {
    width: 100%;
    display: flex;
  }
}
</style>
